import React from 'react';

function ManagesLogsPage() {
    return <div>ManagesLogsPage</div>;
}

export default ManagesLogsPage;
